module.exports = __webpack_public_path__ + "static/media/profile_pic_circle2.d7a9b88b.png";